export const environment = {
  production: false,
  apiBaseUrl: 'http://localhost:8000',
  recaptchaSiteKey: '6LfqgtcsAAAAAD_fUjZFRwu87O9DSLisWEooQOZv'
};

